import { useEffect, useState } from "react";
import { routeFromPath } from "./routes";

export function useRoute() {
  const currentRoute = () => ({ ...routeFromPath(window.location.pathname), pathname: window.location.pathname, search: window.location.search });
  const [route, setRoute] = useState(currentRoute);
  useEffect(() => {
    const update = () => setRoute(currentRoute());
    window.addEventListener("popstate", update);
    if (window.location.pathname === "/") window.history.replaceState({}, "", route.path);
    return () => window.removeEventListener("popstate", update);
  }, [route.path]);
  const navigate = (path) => {
    const target = new URL(path, window.location.origin);
    if (`${window.location.pathname}${window.location.search}` !== `${target.pathname}${target.search}`) window.history.pushState({}, "", path);
    setRoute({ ...routeFromPath(target.pathname), pathname: target.pathname, search: target.search });
  };
  return { route, navigate };
}
